import { useCallback, useEffect, useRef, useState } from 'react';
import { hasComplexDescriptionContent, hasComplexRenderedDescriptionContent } from '../utils/description-content.util';
export var useDescriptionCollapse = function useDescriptionCollapse(_ref) {
  var description = _ref.description,
      _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? true : _ref$enabled;
  var contentRef = useRef(null);

  var _useState = useState(0),
      collapsedHeight = _useState[0],
      setCollapsedHeight = _useState[1];

  var _useState2 = useState(0),
      contentHeight = _useState2[0],
      setContentHeight = _useState2[1];

  var _useState3 = useState(false),
      isExpanded = _useState3[0],
      setIsExpanded = _useState3[1];

  var _useState4 = useState(false),
      isOverflowing = _useState4[0],
      setIsOverflowing = _useState4[1];

  var _useState5 = useState(false),
      hasRenderedComplexContent = _useState5[0],
      setHasRenderedComplexContent = _useState5[1];

  var canMeasureCollapse = enabled && !hasComplexDescriptionContent(description);
  var isCollapsible = canMeasureCollapse && !hasRenderedComplexContent;
  useEffect(function () {
    setIsExpanded(false);
    setHasRenderedComplexContent(false);
  }, [description]);
  useEffect(function () {
    var _document$fonts;

    if (!canMeasureCollapse) {
      setIsOverflowing(false);
      setCollapsedHeight(0);
      setContentHeight(0);
      return;
    }

    var element = contentRef.current;
    if (!element) return;
    var isActive = true;

    var checkOverflow = function checkOverflow() {
      if (!isActive) return;

      if (hasComplexRenderedDescriptionContent(element)) {
        setHasRenderedComplexContent(true);
        setIsOverflowing(false);
        setCollapsedHeight(0);
        setContentHeight(0);
        return;
      }

      setHasRenderedComplexContent(false);
      var computedStyle = window.getComputedStyle(element);
      var parsedLineHeight = Number.parseFloat(computedStyle.lineHeight);
      var fontSize = Number.parseFloat(computedStyle.fontSize) || 16;
      var lineHeight = Number.isFinite(parsedLineHeight) ? parsedLineHeight : fontSize * 1.2;
      var nextCollapsedHeight = lineHeight * 4;
      var nextContentHeight = element.scrollHeight;
      setCollapsedHeight(nextCollapsedHeight);
      setContentHeight(nextContentHeight);
      setIsOverflowing(nextContentHeight > nextCollapsedHeight + 1);
    };

    var animationFrameId = window.requestAnimationFrame(checkOverflow);
    var resizeObserver = typeof ResizeObserver === 'undefined' ? undefined : new ResizeObserver(checkOverflow);
    resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.observe(element);
    window.addEventListener('resize', checkOverflow);
    (_document$fonts = document.fonts) === null || _document$fonts === void 0 ? void 0 : _document$fonts.ready.then(checkOverflow);
    return function () {
      isActive = false;
      window.cancelAnimationFrame(animationFrameId);
      resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
      window.removeEventListener('resize', checkOverflow);
    };
  }, [canMeasureCollapse, description]);
  var toggleExpanded = useCallback(function () {
    setIsExpanded(function (currentValue) {
      return !currentValue;
    });
  }, []);
  return {
    contentRef: contentRef,
    collapsedHeight: collapsedHeight,
    contentHeight: contentHeight,
    isCollapsible: isCollapsible,
    isExpanded: isExpanded,
    isOverflowing: isOverflowing,
    toggleExpanded: toggleExpanded
  };
};